<template>
  <crm-dialog
    :visible="dialogRewardPoint"
    @update:visible="closeRewardPointPromotion"
    @close="closeRewardPointPromotion"
    width="87%"
  >
    <div v-if="!isLoading">
      <div class="circle-points">
        <div class="circle-points circle-1">
          <div class="circle-points circle-2">
            <div class="circle-points circle-3">
              <div class="circle-points-text">
                <div v-if="!isError">
                  <div class="circle-points-number">
                    <h1
                      class="circle-points-main-text"
                      id="points-number-earn"
                      ref="points-number"
                    >
                      {{ numberWithCommas(points == "" ? 0 : points) }}
                    </h1>
                  </div>
                  <p class="circle-points-sub-text">{{ (points >= -1 && points &lt;= 1) ? $t('components.history.point') : $t('components.history.point') }}</p>
                </div>
                <div v-else>
                  <h1 class="circle-points-main-text">!</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isError">
        <h1 class="main-text">
          {{ $t('components.home.get-points') }} {{ numberWithCommas(points == "" ? 0 : points) }} {{ (points >= -1 && points &lt;= 1) ? $t('components.history.point') : $t('components.history.point') }}
        </h1>
        <p class="sub-text">
          {{ $t('components.promotion.add-friend-promotion') }}
        </p>
        <p class="sub-text">
          {{ $t('components.points.all-points',{ points: userInfo.point}) }}
        </p>
        
      </div>
      <div v-else>
        <p class="sub-text" v-html="errorMsg"></p>
      </div>
    </div>
    
    <template #footer class="dialog-footer">
      <el-button
        :disabled="isLoading"
        class="ok-btn"
        type="primary"
        @click="closeRewardPointPromotion"
        >{{ $t('components.change-phone.ok') }}</el-button
      >
    </template>
  </crm-dialog>
</template>

<script>
import CrmDialog from "@/components/Dialog";
import { mapActions, mapGetters, mapMutations } from "vuex";
import mixins from "@/helper/mixins";

export default {
  name: "EarnPointsFromBill",
  mixins: [mixins],
  components: {
    CrmDialog,
  },
  data() {
    return {
      isLoading: false,
      points: 0,
      isError: null,
    };
  },
  computed: {
    ...mapGetters({
      dialogRewardPoint: "promotion/dialogRewardPoint",
      promotionRewardPoint: "promotion/promotionRewardPoint",
      userInfo: "user/userInfo"
    }),
    errorMsg() {
      switch (this.isError.code) {
        case 'E99':
          return this.$t('components.promotion.promotion-used');
        default:
          return this.$t('components.home.error-earning');
      }
    },
  },
  async mounted() {
    this.setDataRewardPoint()
  },
  updated() {
    this.resizeFontToFit();
  },
  methods: {
    ...mapActions({
    }),
    ...mapMutations({
      closeRewardPiontDialog: 'promotion/CLOSE_REWARD_POINT_DIALOG',
    }),
    closeRewardPointPromotion(){

      this.closeRewardPiontDialog();
    },
    setDataRewardPoint(){
      if(this.promotionRewardPoint.code == 200){
        this.points = this.promotionRewardPoint.data.point
      }
      else{
        this.isError.code = this.promotionRewardPoint.responseCode
      }
    },
    resizeFontToFit() {
      const element = this.$refs["points-number"];
      if (element) {
        switch (element.textContent.trim().length) {
          case 5: // X,XXX
            element.style.fontSize = "34px";
            break;
          case 6: // XX,XXX
            element.style.fontSize = "28px";
            break;
          case 7: // XXX,XXX
            element.style.fontSize = "24px";
            break;
          case 9: // X,XXX,XXX
            element.style.fontSize = "19px";
            break;
          case 10: // XX,XXX,XXX
            element.style.fontSize = "17px";
            break;
          default:
            element.style.fontSize = "52px";
            break;
        }
      }
    },
   
  },
};
</script>

<style>
.circle-points {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: 16px;
}
.circle-1 {
  background-color: rgba(
    var(--primary-r),
    var(--primary-g),
    var(--primary-b),
    0.1
  );
  width: 144px;
  height: 144px;
}
.circle-2 {
  background-color: rgba(
    var(--primary-r),
    var(--primary-g),
    var(--primary-b),
    0.2
  );
  width: 112px;
  height: 112px;
}
.circle-3 {
  background-color: var(--primary);
  opacity: 1;
  width: 80px;
  height: 80px;
}
.circle-points-text {
  display: flex;
  flex-direction: column;
}
.circle-points-number {
  position: relative;
  width: 60px;
  height: 32px;
}
.circle-points-main-text {
  margin: 0;
  color: white;
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
}
.circle-points-sub-text {
  margin: 0;
  color: white;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
}

.main-text {
  margin: 0;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
}
.sub-text {
  margin: 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
}

.ok-btn {
  width: 100%;
}

.resizeme {
  resize: both;
  margin: 0;
  padding: 0;
  height: 75px;
  width: 500px;
  background-color: lightblue;
  overflow: hidden;
}
</style>